module.exports = __webpack_public_path__ + "media/sf_cartoon_ohoh_02.f3ddde2f.mp3";